export default __webpack_public_path__ + "static/media/plus_icon_B.85457c89.svg";